import React, { useMemo, useState } from "react";
import SocialCards from "../ui/card-fan-carousel";
import { ImageLightbox } from "./ImageLightbox";

export function CaseStudyCarousel({ images, title }) {
  const slides = useMemo(() => (images ?? []).filter(Boolean), [images]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const cards = useMemo(() => {
    return slides.map((image, index) => ({
      imgUrl: image.src,
      alt: image.alt || `${title ?? "Project"} screenshot ${index + 1}`,
      position: image.position ?? "center top",
    }));
  }, [slides, title]);

  if (!cards.length) return null;

  return (
    <div className="case-carousel-wrapper w-full overflow-hidden flex flex-col items-center justify-center">
      <SocialCards
        cards={cards}
        onCardClick={(index) => setExpandedIndex(index)}
        isPaused={expandedIndex !== null}
      />
      {expandedIndex !== null && (
        <ImageLightbox
          images={slides}
          initialIndex={expandedIndex}
          title={title}
          onClose={() => setExpandedIndex(null)}
        />
      )}
    </div>
  );
}
